module.exports = __webpack_public_path__ + "img/oracle.ab09e935.svg";